// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__pYFhe {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 2rem;
}

.styles_cardInfo__I4Lyb{
  background-color: white;
  padding: 10px;
  border-radius: 15px;
}

.styles_container__pYFhe {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.styles_pdfWrapper__V7LvE {
  position: relative;
}

.styles_pdfContainer__onaFe {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.styles_overlay__SxZ3C {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: transparent;
}

.styles_protectionScreen__tJxcl {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.styles_protectionAlert__56pvl {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  text-align: center;
}

.styles_protectionIcon__ZM1vC {
  display: block;
  margin-bottom: 12px;
}

.styles_protectionBtn__ZwF-- {
  margin-top: 16px;
}

.styles_pdfContainer__onaFe canvas {
  max-width: 100%;
  height: auto !important;
  display: block;
  margin: 0 auto; /* centraliza as páginas, mesmo em landscape */
}`, "",{"version":3,"sources":["webpack://./src/pages/ProcessosInternos/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,cAAc,EAAE,8CAA8C;AAChE","sourcesContent":[".container {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.cardInfo{\n  background-color: white;\n  padding: 10px;\n  border-radius: 15px;\n}\n\n.container {\n  position: relative;\n  user-select: none;\n}\n\n.pdfWrapper {\n  position: relative;\n}\n\n.pdfContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  background-color: transparent;\n}\n\n.protectionScreen {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n}\n\n.protectionAlert {\n  background: #fff;\n  padding: 24px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.protectionIcon {\n  display: block;\n  margin-bottom: 12px;\n}\n\n.protectionBtn {\n  margin-top: 16px;\n}\n\n.pdfContainer canvas {\n  max-width: 100%;\n  height: auto !important;\n  display: block;\n  margin: 0 auto; /* centraliza as páginas, mesmo em landscape */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__pYFhe`,
	"cardInfo": `styles_cardInfo__I4Lyb`,
	"pdfWrapper": `styles_pdfWrapper__V7LvE`,
	"pdfContainer": `styles_pdfContainer__onaFe`,
	"overlay": `styles_overlay__SxZ3C`,
	"protectionScreen": `styles_protectionScreen__tJxcl`,
	"protectionAlert": `styles_protectionAlert__56pvl`,
	"protectionIcon": `styles_protectionIcon__ZM1vC`,
	"protectionBtn": `styles_protectionBtn__ZwF--`
};
export default ___CSS_LOADER_EXPORT___;
